module.exports = __webpack_public_path__ + "static/img/lin2.61106cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lin2.jpg
// module id = y1vR
// module chunks = 1